import { Deposit } from '@core/models/deposit.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap, map, concatMap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { DepositLimit } from '@core/models/deposit-limit.model';
import { Pagination } from '@core/models/pagination.model';

@Injectable()
export class DepositEntityService extends EntityCollectionServiceBase<Deposit> {
  pagination: Pagination;
  messages$ = new Subject<any[]>();
  constructor(
    serviceElementsFactory: EntityCollectionServiceElementsFactory,
    private http: HttpClient
  ) {
      super('Deposit', serviceElementsFactory);
  }

  // optional: custom API call if needed
  getWithQueryNew(query: string): Observable<Deposit[]> {
    return this.http.get<ApiResponse>(`/deposit/indexnew${query}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getByIdNew(id: number): Observable<Deposit>{
    return this.http.get<ApiResponse>(`/deposit/shownew/${id}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    )
  }

  updateNew(id: number, deposit: any, options?: { silent?: boolean }) {
    return this.http.put<ApiResponse>(`/deposit/updatenew/${id}`, deposit).pipe(
      tap(res => {
        if (!options?.silent) {
          this.messages$.next(res.message);
        }
      })
    );
  }

  addNew(deposit: Deposit): Observable<any>{
    return this.http.post<ApiResponse>(`/deposit/storenew`, deposit).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  private paginationInit(res: any) {
    if(res) {
      this.pagination = res.data.paginations;
    }
  }
}
